import { Switch } from "antd";
import { FormLabel } from "./FormLabel";
import { useEffect, useState } from "react";
import { useFirebase } from "../../hooks/firebase/useFirebase";

export const GenericSwitch = ({
  label,
  updateFormValue,
  field,
  checked,
  end,
  docRef,
  ...props
}) => {
  const [value, setChecked] = useState(checked);
  const { updateData } = useFirebase();

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  function updateSwitch(checked) {
    setChecked(checked);
    if (docRef) updateData(docRef, { [field || "active"]: checked });
  }

  return (
    <div
      className="flexNullCenter gap10"
      style={{ justifyContent: end && "flex-end" }}
    >
      <FormLabel info="While turned off, this item will not be visible to users">
        {label}
      </FormLabel>
      <Switch
        defaultChecked
        checked={value}
        onChange={
          updateFormValue
            ? (checked) => updateFormValue(field || "active", checked)
            : updateSwitch
        }
        style={{ fontSize: 9 }}
        checkedChildren="On"
        unCheckedChildren="Off"
        {...props}
      />
    </div>
  );
};
